"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractAuthenticator = void 0;
const oidc_1 = require("../oidc");
/**
 * Performs JWT verification on accessToken to assess authentication
 *
 * Needed if you are a server-side app that hasn't directly received
 * a token from the OIDC endpoint - not needed if you're a webapp or
 * mobile-app that has some an actual authentication already.
 *
 * To get info on a user in this scenario, check Authorizer.
 */
class AbstractAuthenticator {
    constructor({ authority, signingKeyId, audiences }, logger = null) {
        this.authority = authority ?? oidc_1.AUTHORITY_URL;
        this.signingKeyId = signingKeyId ?? oidc_1.SIGNING_KEY_ID;
        this.audiences = audiences;
        this.logger = logger;
    }
}
exports.AbstractAuthenticator = AbstractAuthenticator;
